( function( $, document, window ) {
	'use strict';

	$( function() {        
		const swiper = new Swiper('.js-image-gallery', {
			direction: 'horizontal',
			slidesPerView: 1.25,
			spaceBetween: 20,
			loop: true,
			grabCursor: true,
            centeredSlides: true,
			centeredSlidesBounds: false,

			pagination: {
				el: '.js-image-gallery-pagination',
				clickable: true,
			},

            navigation: {
                prevEl: '.js-image-gallery-prev',
                nextEl: '.js-image-gallery-next',
            },

			breakpoints: {
                580: {
                    slidesPerView: 2,
                    spaceBetween: 32,
                },
			},

			on: {
				beforeInit: function () {
					let numSlides = this.wrapperEl.querySelectorAll( '.js-image-gallery-item' ).length;
					if ( numSlides <= 4 ) {
						this.params.loop = false;
						this.params.centeredSlidesBounds = true;
					}
				}
			}
		});
	} );
} )( jQuery, document, window );
